import Modal from 'components/Modal';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import FormulationReviewContent from './components/FormulationReviewContent';
import FormulationReviewModalFooter from './components/FormulationReviewModalFooter';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FormulationReviewModal: FunctionComponent<Props> = ({
    chemicalId,
    isOpen,
    onClose,
    onFormulationChanged,
    testId = TEST_ID
}) => {
    const data = useData({ chemicalId, isOpen, onClose, onFormulationChanged });
    const t = useTranslation();

    return (
        <Modal
            footer={
                <FormulationReviewModalFooter
                    canClear={data.canClear}
                    canVerify={data.canVerify}
                    isBusy={data.isBusy}
                    isConfirmEnabled={data.isConfirmEnabled}
                    onCancel={data.onRequestClose}
                    onClear={data.onClear}
                    onConfirm={data.onConfirm}
                    onRetry={data.onRetry}
                    reviewState={data.reviewState}
                />
            }
            isOpen={isOpen}
            onClose={data.onRequestClose}
            testId={testId}
            title={t.TITLE}>
            <FormulationReviewContent
                actionError={data.actionError}
                canVerify={data.canVerify}
                documents={data.documents}
                evidence={data.evidence}
                hasContradiction={data.hasContradiction}
                isBusy={data.isBusy}
                labelMixingNote={data.labelMixingNote}
                onEvidenceChange={data.onEvidenceChange}
                onLabelMixingNoteChange={data.onLabelMixingNoteChange}
                onSelectStatement={data.onSelectStatement}
                reviewState={data.reviewState}
                selectedStatementKey={data.selectedStatementKey}
                suggestedCodes={data.suggestedCodes}
            />
        </Modal>
    );
};

export default FormulationReviewModal;
